import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
  HoursQueryParams,
  HoursSummaryQueryParams,
  HoursListResponse,
  HoursSummaryResponse,
} from '@com.maessa.payroll.frontend/models';

@Injectable({ providedIn: 'root' })
export class HoursApiService extends BaseApiService {

  /** GET /api/v1/hours — listado paginado de time_entries */
  getHours(params?: HoursQueryParams): Observable<HoursListResponse> {
    const httpParams = this.buildParams((params ?? {}) as Record<string, unknown>);
    return this.get<HoursListResponse>(`${this.baseUrl}/hours`, httpParams);
  }

  /** GET /api/v1/hours/summary — totales y desgloses agregados */
  getHoursSummary(params?: HoursSummaryQueryParams): Observable<HoursSummaryResponse> {
    const httpParams = this.buildParams((params ?? {}) as Record<string, unknown>);
    return this.get<HoursSummaryResponse>(`${this.baseUrl}/hours/summary`, httpParams);
  }
}

